// EntryFormSelector.tsx
import { useState } from 'react';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import Skill from './Skills';
import Language from './Language';
import Experience from './Experience';
import Courses from './Course';
import Link from './Link';
import Hobby from './Hobby';

const EntryFormSelector = () => {
  const [selected, setSelected] = useState('skill');

  const renderForm = () => {
    switch (selected) {
      case 'hobby':
        return <Hobby />
      case 'link':
        return <Link />
      case 'course':
        return <Courses />
      case 'skill':
        return <Skill />;
      case 'language':
        return <Language />;
      case 'work':
      case 'internship':
      case 'education':
        return <Experience type={selected} />;
      default:
        return null;
    }
  };

  return (
    <div>
      <DropdownButton style={{marginTop: '6px'}} title={`Select: ${selected}`} onSelect={(eventKey) => setSelected(eventKey!)}>
        <Dropdown.Item eventKey="hobby">Hobby</Dropdown.Item>
        <Dropdown.Item eventKey="skill">Skill</Dropdown.Item>
        <Dropdown.Item eventKey="language">Language</Dropdown.Item>
        <Dropdown.Item eventKey="link">Link</Dropdown.Item>
        <Dropdown.Item eventKey="course">Course</Dropdown.Item>
        <Dropdown.Item eventKey="work">Work</Dropdown.Item>
        <Dropdown.Item eventKey="internship">Internship</Dropdown.Item>
        <Dropdown.Item eventKey="education">Education</Dropdown.Item>
      </DropdownButton>
      <div style={{ marginTop: '1rem' }}>
        {renderForm()}
      </div>
    </div>
  );
};

export default EntryFormSelector;
